<script>
  import AnimatedBlock from '../components/AnimatedBlock.svelte'
  import AnimatedTitle from '../components/AnimatedTitle.svelte'
  import Accordion from '../components/Accordion.svelte'
  import Chart1 from '../charts/ReachVsLinear.svelte'
  import Chart2 from '../charts/OptimalFrequency.svelte'
</script>
<section class="part7">
  <div class="rgrid-md-1-2">
    <div class="col">
      <AnimatedTitle class="medium">Understand the impact of your investment.</AnimatedTitle>
      <AnimatedBlock><p>Tap into proprietary measurement solutions that show you optimal frequency, incremental reach versus linear TV, and purchase and brand lift.</p></AnimatedBlock>
    </div>
    <div class="col">
      <Accordion title="Incremental reach vs Linear" id="incremental_reach_vs_linear" expandedOnDesktop={true} hideTitleOnDesktop={false}>
        <Chart1 />
        <div class="hline"></div>
        <Chart2 />
      </Accordion>
    </div>
  </div>
</section>

<style>
  section :global(.hline) {
    height: 1px;
    background: white;
    margin: 1.5625rem 0 1.25rem;
  }
  section :global(.accordion) {
    margin-top: 4rem;
  }
  section :global(.accordion .chart:first-of-type) {
    margin-top: 2rem;
  }
  @media(min-width: 768px) {
    section :global(.accordion) {
      margin-top: 0;
    }
  }
</style>